import React from 'react'
import {AlertDialog} from 'react-onsenui'
import Loader from 'react-loader-spinner';
import firebase from 'firebase/app';
import 'firebase/database';

import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import {showToastMessage} from "../../modules/toast";
import {addUserInfo} from "../../modules/user";
import {showAlertMessage} from "../../modules/alert";
import {showTutorial} from "../../modules/tutorial";

class AddUserInfoDialog extends React.Component {
    state = {
        nickname: '',
        isLoading: false,
    };

    componentDidMount(){
        if(this.props.userInfo){
            this.fillPreviousInformation(this.props.userInfo);
        }
        
        if(this.props.first){
            this.props.showToastMessage('처음 오신분은 추가 사용자 정보를 입력해주세요.');
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.userInfo){
            this.fillPreviousInformation(nextProps.userInfo);
        }

        if(!this.props.first && nextProps.first){
            this.props.showToastMessage('처음 오신분은 추가 사용자 정보를 입력해주세요.');
        }
    }

    componentWillMount() {
    }

    fillPreviousInformation = (userInfo) => {
        const nickname = userInfo.nickname && userInfo.nickname !== '' ?  userInfo.nickname :  userInfo.name;

        this.setState({
            nickname: nickname
        });
    };

    fillInForm = (type, event) => {
        switch (type){
            case 'nickname':
                this.setState({'nickname': event.target.value});
                break;
            default:
                console.error('NO TARGET');
        }
    };

    changeUserInfo = () => {
        const {nickname} = this.state;
        if(nickname.length < 3 || nickname.length > 20){
            this.props.showToastMessage('닉네임은 3자 이상 20자 이하입니다.');
            return;
        }
        this.setState({isLoading: true});

        let fu = {
            email: this.props.userInfo.email,
            gender: this.props.userInfo.gender,
            age: this.props.userInfo.age,
            name: this.props.userInfo.name,
            nickname: nickname
        };

        firebase.database().ref('users/' + this.props.userInfo.uid).set(fu)
            .then(() => {
                let userInfo = this.props.userInfo;
                userInfo.nickname = nickname;
                this.props.addUserInfo(userInfo);

                this.props.showToastMessage('사용자 정보를 변경하였습니다.');
                if(this.props.first){
                    this.props.showTutorial('ENTIRE_OVERVIEW');
                }
                this.props.hide();
            });
    };

    render() {
        return (
           <div>
               <AlertDialog className="add-user-info-alert-dialog" isOpen={this.props.open} cancelable={false} modifier={'material'}>
                   <div className="alert-dialog-title">정보 수정</div>
                   <div className="alert-dialog-content">
                       <div>
                           닉네임
                       </div>
                       <div>
                           <input className="text-input text-input--material" placeholder="닉네임" type="text" value={this.state.nickname} onChange={(e) => this.fillInForm('nickname', e)}/>
                       </div>
                   </div>
                   {
                       !this.state.isLoading ?
                           <div className="alert-dialog-footer">
                               {
                                   !this.props.first ?
                                       <button className="alert-dialog-button alert-dialog-button-no" onClick={() => this.props.hide()}>
                                           취소
                                       </button>
                                       :
                                       null
                               }
                               <button className="alert-dialog-button alert-dialog-button-yes" onClick={this.changeUserInfo}>
                                   저장
                               </button>
                           </div>
                           :
                           <div className="alert-dialog-footer">
                               <div className='text-center'>
                                   <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                               </div>
                           </div>
                   }
               </AlertDialog>
           </div>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo
});

const mapDispatchToProps = dispatch => ({
    addUserInfo: userInfo => dispatch(addUserInfo(userInfo)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showTutorial: (sort) => dispatch(showTutorial(sort)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(AddUserInfoDialog))